module.exports = __webpack_public_path__ + "static/media/primary-header-bgi.c0307904.png";